import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-detail-tep-projet',
  templateUrl: './detail-tep-projet.component.html',
  styleUrl: './detail-tep-projet.component.scss'
})

export class DetailTepProjetComponent {

  // breadcrumb items
  submitted: boolean=false;
  tacheData: any = [];
  modalRef: NgbModalRef | null = null;
  @ViewChild('detailModal') modalContent!: TemplateRef<any>;
  activiteOp: any = {};
  paginatedItems: any[] = [];
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  //action
  paginatedItemsAction: any[] = [];
  firstaAction: number = 0;
  rowsAction: number = 10;
  totalRecordsAction: number = 0;
  //

  // Nombre total d'éléments
  isLoading: boolean = false;
  fitreTache: any;
  annee: any;
  userInfo: any;
  directionId: any;
  dateDebut: string;
  dateFin: string;
  projetId: any
  itemDetail: any;
  detailsAction: any = [];
  detailsActivite: any = [];

  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {

    this.projetId = this.localstorage.getTepProjet();
    console.log("projetId", this.projetId);

    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.userInfo = this.localstorage.getInfoUserToService();
    this.activiteOp = this.localstorage.getTepProjet();
    console.log(" this.activiteOp", this.activiteOp);

    this.dateDebut = this.localstorage.getDateToDetail()?.date_debut;
    this.dateFin = this.localstorage.getDateToDetail()?.date_fin;
    ////console.log("this.dateDebut",this.dateDebut);  
    this.getActionByProgramme();
  }

  getActionByProgramme() {

    const requestData = {
      programme_id: this.projetId.programme.id,
      date_debut: this.dateDebut,
      date_fin: this.dateFin
    }

    this.ngxService.start();
    this.paramservice.getStatsActionByProgramme(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();

        console.log("la réponse du webservice", response);
        this.detailsAction = response.data;
        this.totalRecordsAction = this.detailsAction.length;
        this.updateListAction();
        this.ngxService.stop();
      },
      (error: any) => {
        console.log("une erreur est survenu", error);
        this.ngxService.stop();
      }
    )

  }

  close() {
    this.modalService.dismissAll()
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updateList();
  }

  onPageChangeAction(event: any) {
    this.firstaAction = event.first;
    this.rowsAction = event.rows;
    this.updateListAction();
  }

  actId:any;
  Consulter(item: any) {
    console.log("item", item);

    this.actId = item;
    let requestData = {

      action_id: item?.action?.id,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: "data"
    }
    this.ngxService.start();
    this.paramservice.getStatsActiviteByProjet(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();

        console.log("la réposne du webservice", response)
        this.detailsActivite = response.data;
        this.totalRecords = this.detailsActivite.length;
        this.updateList();

      },
      (error: any) => {
        this.ngxService.stop();

        console.log("une erreru est survenu", error);

      }
    )
    this.modalService.open(this.modalContent, {
      size: 'xl',
      backdrop: 'static',
      keyboard: false
    });
  }
  updateList() {

    const start = this.first;
    const end = this.first + this.rows;
    this.paginatedItems = this.detailsActivite.slice(start, end);

  }
  updateListAction() {
    const start = this.firstaAction;
    const end = this.firstaAction + this.rowsAction;
    this.paginatedItemsAction = this.detailsAction.slice(start, end);
  }

  roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
  }

  //imprime en pdf et excel
  exportToDocument(typeDoc: any) {
    
    let requestData = {
      action_id: this.actId?.action?.id,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      type_operation: typeDoc
    }
    this.ngxService.start();

    this.paramservice.getStatsActiviteByProjetDoc(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'tep_Programme.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'tep_Programme.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
          (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );
  }//end exportToDocument



}